<template>
    <div class="bg-white rounded-lg shadow-lg p-6 w-full transform transition-transform hover:scale-105 hover:shadow-xl">
      <img :src="image" alt="Property Image" class="w-full h-48 object-cover rounded-lg">
      <div class="mt-6">
        <h2 class="text-3xl font-bold text-orange-600">{{ price }}</h2>
        <p class="text-gray-700 mt-4">{{ description }}</p>
        <div class="flex items-center justify-between mt-6">
          <div>
            <p class="text-gray-600"><strong>Kamar Tidur:</strong> {{ bedrooms }}</p>
            <p class="text-gray-600"><strong>Kamar Mandi:</strong> {{ bathrooms }}</p>
            <p class="text-gray-600"><strong>Carport:</strong> {{ carport }}</p>
            <p class="text-gray-600"><strong>Luas Tanah:</strong> {{ landSize }} m²</p>
            <p class="text-gray-600"><strong>Luas Bangunan:</strong> {{ buildingSize }} m²</p>
          </div>
          <div class="text-center">
            <img :src="agentImage" alt="Agent Image" class="w-14 h-14 rounded-full mx-auto">
            <p class="text-gray-600 mt-2">{{ agentName }}</p>
            <a :href="whatsappLink" class="text-green-600 flex items-center justify-center mt-2">
              <svg class="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M...Z"/> <!-- WhatsApp SVG path -->
              </svg>
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'PropertyCard',
    props: {
      image: String,
      price: String,
      description: String,
      bedrooms: Number,
      bathrooms: Number,
      carport: Number,
      landSize: Number,
      buildingSize: Number,
      agentImage: String,
      agentName: String,
      whatsappLink: String,
    },
  });
  </script>

  <style scoped>
  /* Additional styles if needed */
  </style>
